import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useUser } from '../../context/UserContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { API_BASE_URL } from '../dashboardContent/config'; 
import { useLocation, useNavigate } from 'react-router-dom';
import { getFirstBaccalaureateOptions } from '../../constants/firstBaccalaureateOptions';

import '../../StylesCSS/StudentSelector.css';  // Import du fichier CSS
import BranchLabelBanner from './BranchLabelBanner';


const StudentSelector = ({ setActiveSection }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const routeContext = location.state || {};
    const {
        branch,
        branchLabel,
        action,
    } = routeContext;
    const firstBaccalaureateOptions = getFirstBaccalaureateOptions(branchLabel);
    const { userId } = useUser(); 

    /* Start MSL30082026 */
    const [institutions, setInstitutions] = useState([]);
    const [selectedInstitution, setSelectedInstitution] = useState('');
    const [classes, setClasses] = useState([]);
    const [selectedClass, setSelectedClass] = useState('');
    const [students, setStudents] = useState([]);
    const [currentStudentIndex, setCurrentStudentIndex] = useState(0);
    const [excelFileId, setExcelFileId] = useState(null);
    const [seuil, setSeuil] = useState(0);
    const [nextClicked, setNextClicked] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    /* Start MSL30082026 */
    useEffect(() => {
        axios.get(`${API_BASE_URL}/version2/api/seuil/${userId}`, {
            params: {
                branch: branch || '',
                branchLabel: branchLabel || '',
            },
        })
            .then(response => {
                setSeuil(response.data.seuil); // Récupère la valeur du seuil
                console.log("Seuil récupéré:", response.data.seuil); // Affiche la valeur du seuil récupérée
            })
            .catch(error => console.error('Erreur lors de la récupération du seuil:', error));
    }, [userId, branch, branchLabel]);
    /* End MSL30082026 */
    
    console.log("seuil",seuil);
    // Nouveaux états pour les inputs
    const [decisionConseil, setDecisionConseil] = useState('');
    const [langueEtrangere, setLangueEtrangere] = useState('');
    console.log("decisionConseil",decisionConseil);
    console.log("langueEtrangere",langueEtrangere);

    useEffect(() => {
        if (students.length > 0) {
            const currentStudent = students[currentStudentIndex];
            console.log("currenntStudent",currentStudent);
    
            // Récupérer les valeurs de décision du conseil et langue étrangère pour l'étudiant actuel
            axios.get(`${API_BASE_URL}/version2/api/students/${currentStudent.id}`)
                .then(response => {
                    const studentData = response.data;
                    setDecisionConseil(studentData.decisionConseil || ''); // Définir la décision du conseil
                    setLangueEtrangere(studentData.deuxiemeLangueEtrangere || ''); // Définir la langue étrangère
                })
                .catch(error => console.error('Erreur lors de la récupération des données de l\'étudiant:', error));
        }
    }, [currentStudentIndex, students]);
    console.log("Liste des étudiants:", students);
console.log("Index actuel de l'étudiant:", currentStudentIndex);



    // Récupérer les institutions
    useEffect(() => {
        axios.get(`${API_BASE_URL}/version2/api/excel/institutions/${userId}`, {
            params: {
                branch: branch || '',
                branchLabel: branchLabel || '',
            },
        })
            .then(response => setInstitutions(response.data))
            .catch(error => console.error('Erreur lors de la récupération des institutions:', error));
    }, [userId, branch, branchLabel]);

    // Récupérer les classes quand une institution est sélectionnée
    useEffect(() => {
        setClasses([]);
        setSelectedClass('');
        setExcelFileId(null);

        if (selectedInstitution) {
            axios.get(`${API_BASE_URL}/version2/api/excel/classes/${userId}/${encodeURIComponent(selectedInstitution)}`, {
                params: {
                    branchLabel: branchLabel || '',
                },
            })
                .then(response => setClasses(response.data))
                .catch(error => console.error('Erreur lors de la récupération des classes:', error));
        }
    }, [selectedInstitution, userId, branchLabel]);

    // Récupérer l'excelFileId lorsque l'institution et la classe sont sélectionnées
    useEffect(() => {
        if (selectedInstitution && selectedClass) {
            axios.get(`${API_BASE_URL}/version2/api/excel/fileId/${userId}/${encodeURIComponent(selectedInstitution)}/${encodeURIComponent(selectedClass)}`, {
                params: {
                    branchLabel: branchLabel || '',
                },
            })
                .then(response => setExcelFileId(response.data.excelFileId))
                .catch(error => console.error('Erreur lors de la récupération de l\'ID du fichier Excel:', error));
        }
    }, [selectedInstitution, selectedClass, userId, branchLabel]);

    const fetchStudents = () => {
        if (excelFileId) {
            axios.get(`${API_BASE_URL}/version2/api/students/byExcelFile`, {
                params: {
                    excelFileId,
                    branch: branch || '',
                    branchLabel: branchLabel || '',
                },
            })
                .then(response => setStudents(response.data))
                .catch(error => console.error('Erreur lors de la récupération des étudiants:', error));
        } else {
            console.error('excelFileId est requis');
        }
    };

    /* Start MSL30082026 */
    const handleNextStudent = () => {
        if (currentStudentIndex < students.length) {
            const currentStudent = students[currentStudentIndex];

            console.log('=== StudentSelector: mise à jour étudiant ===');
            console.log('branch:', branch);
            console.log('branchLabel:', branchLabel);
            console.log('selectedInstitution:', selectedInstitution);
            console.log('selectedClass:', selectedClass);
            console.log('currentStudentId:', currentStudent.id);
            console.log('payload envoyé:', {
                ...currentStudent,
                decisionConseil: decisionConseil,
                deuxiemeLangueEtrangere: langueEtrangere
            });
    
            // Mettre à jour l'étudiant avec les données actuelles
            axios.put(`${API_BASE_URL}/version2/api/students/updateStudent/${currentStudent.id}`, {
                ...currentStudent,
                decisionConseil: decisionConseil,
                deuxiemeLangueEtrangere: langueEtrangere,
                branch: branch || '',
                branchLabel: branchLabel || '',
            })
            .then(() => {
                // Vérifier si nous sommes sur le dernier étudiant
                if (currentStudentIndex < students.length - 1) {
                    // Si ce n'est pas le dernier étudiant, passer au suivant
                    setCurrentStudentIndex(currentStudentIndex + 1);
                    setNextClicked(false);  // Réinitialiser la variable "nextClicked"
                } else {
                    // Si c'est le dernier étudiant, griser le bouton et ouvrir le modal
                    setNextClicked(true); // Réinitialiser l'état pour griser le bouton
                    setIsModalOpen(true); // Ouvrir le modal
                }
    
                // Réinitialiser les valeurs pour le prochain étudiant
                setDecisionConseil('');
                setLangueEtrangere('');
            })
            .catch(error => console.error('Erreur lors de la mise à jour de l\'étudiant:', error));
        }
    };
    /* End MSL30082026 */
    
    
    // Désactiver le bouton après la mise à jour du dernier étudiant
    const closeModal = () => {
        setIsModalOpen(false);
    };
    

    /* Start MSL30082026 */
    const handlePreviousStudent = () => {
        if (currentStudentIndex > 0) {
            setCurrentStudentIndex(currentStudentIndex - 1);
        }
    };
    const handleGoBack = (section) => {
        navigate(`/${section}`, {
            state: {
                branch,
                branchLabel,
                action,
            },
        });
      };
    /* End MSL30082026 */

      // Vérifier si students est défini et que currentStudentIndex est valide
const noteTotal = (students.length > 0 && currentStudentIndex >= 0 && currentStudentIndex < students.length)
? parseFloat(students[currentStudentIndex].noteTotal.replace(',', '.'))
: 0; // ou une autre valeur par défaut

const seuilValue = parseFloat(seuil);
console.log("noteTotal)>",noteTotal);



    return (
        <div className="container">
            <div
          style={{
            display: "flex",
            justifyContent: "center", // Centrage horizontal
            alignItems: "center",

            backgroundColor: "#00B9B9",
            padding: "16px",
            borderRadius: "8px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
            direction: "rtl",
            fontFamily: "Arial, sans-serif",
            fontSize: "22px",
            fontWeight: "bold",
            height: "80px",
            gap: "20px",
          }}
        >
          {/* Carré à droite (début de ligne en arabe) */}
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#FF9900",
              borderRadius: "2px",
            }}
          ></div>

          {/* Texte arabe centré */}
          <span>تدبير مجالس الأقســــام للجدع المشترك</span>

          {/* Carré à gauche (fin de ligne en arabe) */}
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#FF9900",
              borderRadius: "2px",
            }}
          ></div>
        </div>
                        <BranchLabelBanner branchLabel={branchLabel} style={{ marginTop: '12px' }} />
        <br></br>
         <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <button onClick={() => handleGoBack('PageLayoutActionsV2')} className="back-btn">
            <FontAwesomeIcon icon={faArrowLeft} /> رجوع
          </button>
        </div>

            <h5 className="title" style={{ textAlign: 'right' }} > : اختر المؤسسة</h5>
            <select className="select" onChange={(e) => setSelectedInstitution(e.target.value)} value={selectedInstitution}>
                <option value="" style={{ textAlign: 'right' }} >-- اختر --</option>
                {institutions && institutions.length > 0 && institutions.map(institution => (
                    <option style={{ textAlign: 'right' }}  key={institution} value={institution}>{institution}</option>
                ))}
            </select>

            {selectedInstitution && (
                <>
                    <h5 className="title" style={{ textAlign: 'right' }} > : اختر القسم</h5>
                    <select className="select" onChange={(e) => setSelectedClass(e.target.value)} value={selectedClass}>
                        <option value="" style={{ textAlign: 'right' }} >-- اختر --</option>
                        {classes && classes.length > 0 && classes.map(classe => (
                            <option style={{ textAlign: 'right' }}  key={classe} value={classe}>{classe}</option>
                        ))}
                    </select>
                </>
            )}

            {selectedClass && (
                <>
    <div className="buttonContainer">
        <button className="button" onClick={fetchStudents}>Afficher les étudiants</button>
    </div>

    {students.length > 0 && (
        <div className="studentInfo">
            <h5 style={{ textAlign: 'right' }} >التلميذ {currentStudentIndex + 1}/{students.length}</h5>
            <br></br>
            <p style={{ textAlign: 'right' }} ><strong>  الاسم الكامل : </strong> {students[currentStudentIndex].nomEtPrenom}</p>
            <p style={{ textAlign: 'right' }} > {students[currentStudentIndex].numeroEleve} <strong> : رقم التلميذ </strong></p>

            <div className="infoBoxContainer">
                {/* Niveau actuel */}
                <div className="infoBox">
                    <p className="infoBoxLabel" > الثالثة</p>
                    <p className="infoBoxValue">{students[currentStudentIndex].niveauActuel}</p>
                </div>
                
                {/* un an avant */}
                <div className="infoBox">
                    <p className="infoBoxLabel">الثانية </p>
                    <p className="infoBoxValue">{students[currentStudentIndex].un_an_avant}</p>
                </div>
                
                {/* deux ans avant */}
                <div className="infoBox">
                    <p className="infoBoxLabel">الاولى</p>
                    <p className="infoBoxValue">{students[currentStudentIndex].deux_an_avant}</p>
                </div>
            </div>
        
            <div className="noteTotalBox">
            <p><strong>المعدل العام  :  </strong> {students[currentStudentIndex].noteTotal}</p>
           </div>
           <br></br>

            <div className="formContainer">
   {/* Décision du Conseil */}
<div className="formGroup">
    <label className="formLabel" style={{ textAlign: 'right' }}>: قرار المجلس</label>
    <select 
        className="formSelect"
        value={decisionConseil} 
        onChange={(e) => setDecisionConseil(e.target.value)}
        style={{ textAlign: 'right' }} 
    >
        <option value="">-- اختر --</option>
        {students.length > 0 && (
            // Afficher les options basées sur noteTotal et seuilValue
            noteTotal >= seuilValue ? (
                <>
                    {firstBaccalaureateOptions.map((option) => (
                        <option key={option} value={option}>{option}</option>
                    ))}

                </>
            ) : (
                <>
                    <option value="يكرر">يكرر</option>
                    <option value="يكرر بقرار">يكرر بقرار</option>
                    <option value="يفصل">يفصل</option>
                </>
            )
        )}
    </select>
</div>



<div className="formGroup">
    <label className="formLabel" style={{ textAlign: 'right' }}> : اللغة الاجنبية الثانية</label>
    <select 
        className="formSelect"
        value={langueEtrangere || ''} // Utilisez une valeur par défaut vide si aucune valeur n'est définie
        onChange={(e) => setLangueEtrangere(e.target.value)}
        style={{ textAlign: 'right' }}
    >
        <option value="">-- اختر --</option>
        
        {/* Afficher la langue actuelle récupérée depuis la base de données */}
        {students.length > 0 && students[0].langueEtrangere && (
            <option value={students[0].langueEtrangere}>
                {students[0].langueEtrangere}
            </option>
        )}

        {/* Les 3 options disponibles pour changer la langue */}
        <option value="اللغة الألمانية">اللغة الألمانية</option>
        <option value="اللغة الإنجليزية">اللغة الإنجليزية</option>
        <option value="اللغة الإسبانية">اللغة الإسبانية</option>
    </select>
</div>



</div>
{isModalOpen && (
  <div className="modal-1">
    <div className="modal-content-1">
      <p>  لقد وصلت إلى آخر تلميذ المرجو الرجوع</p>
      <button onClick={closeModal}>Fermer</button>
    </div>
  </div>
)}




            <div className="navigationButtons">
                <button 
                    className="button previous-student-button" 
                    onClick={handlePreviousStudent} 
                    disabled={currentStudentIndex === 0}>
                    <FontAwesomeIcon icon={faChevronLeft} aria-hidden="true" />
                    السابق
                </button>
                <button 
    className="button next-student-button" 
    onClick={handleNextStudent} 
    disabled={currentStudentIndex === students.length - 1 && nextClicked}
>
    <FontAwesomeIcon icon={faChevronRight} aria-hidden="true" />
التالي
</button>


            </div>
        </div>
    )}
</>

            )}
        </div>
    );
};

export default StudentSelector;
